import bandwidthRow from './bandwidth/bandwidth';
import expectedQualityRow from './expectedQuality/expectedQuality';
import jitterRow from './jitter/jitter';
import latencyRow from './latency/latency';
import mediaServersRow from './mediaServers/mediaServers';
import packetLossRow from './packetLoss/packetLoss';
import { Row } from './shared';
import signalingServersRow from './signallingServers/signallingServers';
import timeToMediaRow from './timeToMedia/timeToMedia';

export const rows: Row[] = [
  signalingServersRow,
  mediaServersRow,
  timeToMediaRow,
  jitterRow,
  latencyRow,
  packetLossRow,
  bandwidthRow,
  expectedQualityRow,
];
